<template>
  <div class="jumbotron jumbotron-fluid bg-success text-white">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h6 class="font-weight-light mb-0">{{smallTitle}}</h6>
          <h2 class="mb-0">{{title}}</h2>
          <h5>{{subtitle}}</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      smallTitle: String,
      title: String,
      subtitle: String,
    },
  };
</script>